import ReactDOM from 'react-dom';
import App from './App';
import { reportWebVitals } from './utils';
import 'semantic-ui-less/semantic.less';
import 'react-datepicker/dist/react-datepicker.css';
import 'index.scss';
import { toast, ToastBar, Toaster } from 'react-hot-toast';
import { Button, Icon } from 'semantic-ui-react';
import { ToastDuration } from './constants/toasts';

ReactDOM.render(
  <>
    <div>
      <Toaster
        toastOptions={{
          duration: ToastDuration.STANDARD,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <Button 
                    style={{ 
                      background: 'none',
                      color: 'var(--color-black)',
                      padding: 0,
                    }} 
                    size='mini'
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <Icon name='close' style={{ margin: 0, padding: 0 }}/>
                  </Button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
    <App/>
  </>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
